import imageCompression from 'browser-image-compression';

/**
 * Compress an image file before uploading
 * @param {File} imageFile - The image file to compress
 * @param {Object} options - Compression options
 * @returns {Promise<File>} - Compressed image file
 */ 
export const compressImage = async (imageFile, options = {}) => {
    const defaultOptions = {
        maxSizeMB: 0.5, // Maximum file size in MB
        maxWidthOrHeight: 1920, // Maximum width or height
        useWebWorker: true,
        fileType: imageFile.type, // Preserve original file type
        initialQuality: 0.8, // Initial compression quality
    };

    const compressionOptions = { ...defaultOptions, ...options };

    try {
        console.log('Original file size:', (imageFile.size / 1024 / 1024).toFixed(2), 'MB');

        const compressedFile = await imageCompression(imageFile, compressionOptions);

        console.log('Compressed file size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');

        return compressedFile;
    } catch (error) {
        console.error('Error compressing image:', error);
        throw new Error('Failed to compress image. Please try again.');
    }
};

/**
 * Compress multiple image files
 * @param {FileList|Array} imageFiles - Array of image files to compress
 * @param {Object} options - Compression options
 * @returns {Promise<Array>} - Array of compressed image files
 */
export const compressMultipleImages = async (imageFiles, options = {}) => {
    const filesArray = Array.from(imageFiles);

    try {
        const compressionPromises = filesArray.map(file => compressImage(file, options));
        const compressedFiles = await Promise.all(compressionPromises);

        return compressedFiles;
    } catch (error) {
        console.error('Error compressing multiple images:', error);
        throw new Error('Failed to compress images. Please try again.');
    }
};
